
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.134 17.371h6.194c2.475 0 4.503-1.996 4.503-4.438V9.538c0-1.749-1.452-3.18-3.226-3.18h-8.75c-1.774 0-3.226 1.431-3.226 3.18v3.395c0 2.44 2.025 4.438 4.503 4.438h.002zM7.83 2.171h2.804c.878 0 1.598.798 1.598 1.771v1.772h-6V3.942c0-.973.72-1.77 1.598-1.77z","fill":"#0E6199"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.83 2.171h.287c.336 1.094.56 2.288.647 3.545H6.23V3.945c0-.974.72-1.771 1.598-1.771l.002-.003zM4.537 17.08c2.513-1.703 4.27-5.605 4.27-10.145 0-.195-.003-.387-.01-.577H4.855c-1.774 0-3.226 1.431-3.226 3.18v3.395c0 1.888 1.212 3.509 2.905 4.147h.003z","fill":"#176BA6"}})])
          )
        }
      }
    